import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { AccordionComponent } from 'src/app/components/accordion/accordion.component'
import { TranslationService } from '../../services/translation.service'
@Component({
  selector: 'faq',
  standalone: true,
  imports: [AccordionComponent, CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent implements OnInit {
  translationCode: any
  constructor(private translationService: TranslationService) {}
  ngOnInit() {
    this.translationCode = this.translationService.getTranslationForPage('faq')
  }
  mockData = [
    {
      ques: 'Will I need to pay to access the Stellantis Fleet Service Portal? ',
      ans: 'No, Stellantis Fleet Service Portal will be free to access for all Fleet owners or Fleet managers with a Stellantis connected Service login. Access to Connected Services, digital products and solutions will have their own pricing models. ',
    },
    {
      ques: 'What device is required to access the Stellantis Fleet Service Portal? ',
      ans: 'The Stellantis Fleet Service Portal is a web portal accessible from any computer or tablet equipped with an up-to-date browser. ',
    },
    {
      ques: 'Will my current connected service login or brand login allow me to access the Stellantis Fleet Service Portal? ',
      ans: 'Yes, your existing login will allow you to access the Stellantis Fleet Service Portal to experience a multi-vehicle overview of your vehicles and discover the Fleet Products Ecosystem.  No need to create any other account for this portal. ',
    },
    {
      ques: 'I am Fleet customer with an existing stellantisfleet.com user account, can I access the Stellantis Fleet Service Portal? ',
      ans: 'The short answer is not yet.... but we are working towards it. Our goal is to ensure every fleet customer can access the Stellantis Fleet Service portal but initially, only fleet users that have enrolled in connected services and created a user account can access the portal in its initial release. We anticipate that all fleet customers, including stellantisfleet.com account holders will have access to the platform in 2025.  ',
    },
  ]

  concatData(index: any, data: any) {
    return `Q${index + 1}: ${data}`
  }
  concatAns(data: any) {
    return `A: ${data}`
  }
}
